import type { ProductColor, ToolkitPropertyEnum, syntaxFNMA } from '@aloft/toolkit-shared';
import { makeLookup } from '@aloft/toolkit-shared';

import type { PropertyPinStatus } from '../components/Tkv2Map/types.ts';
import { getPropertyPinStatus } from './getPropertyPinStatus.ts';

const getPinColorForPinStatus = makeLookup<PropertyPinStatus, ProductColor>({
  cases: [
    ['Active', 'pinActive'],
    ['Pending', 'pinPending'],
    ['Sold', 'pinSold'],
    ['Rented', 'pinRented'],
    ['Off-Market', 'pinOffMarket'],
    ['other', 'pinOther'],
    ['Subject', 'pinSubject'],
    ['Subject (ARV)', 'pinSubject'],
  ],
  default: 'pinOffMarket',
});

export const getColorForStatusOrSubject = (
  statusOrSubject:
    | ToolkitPropertyEnum<'ListingStatusType'>
    | syntaxFNMA.RentalListingStatus
    | 'Subject'
    | 'Subject (ARV)' = 'Off-Market',
): ProductColor => getPinColorForPinStatus(getPropertyPinStatus(statusOrSubject));
